import React from 'react';
import { whyChooseUsDetailed } from '../mock';
import { Briefcase, DollarSign, Zap, LifeBuoy } from 'lucide-react';

const iconComponents = {
  Briefcase,
  DollarSign,
  Zap,
  LifeBuoy
};

const WhyChooseUsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#FFB400] uppercase tracking-wide mb-2">
            Why Choose Us
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2B0A12] mb-4">
            Your Trusted IP Protection Partner
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We combine legal expertise, transparent processes, and dedicated support to deliver exceptional results for our clients.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
          {/* Left - Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-full min-h-[500px] order-2 lg:order-1">
            <img 
              src="https://images.unsplash.com/photo-1758873268631-fa944fc5cad2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsc3xlbnwwfHx8fDE3NzA2Nzc1Mjh8MA&ixlib=rb-4.1.0&q=85"
              alt="Professional Team - Trademark Essential"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#2B0A12]/40 to-transparent"></div>
          </div>

          {/* Right - Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 order-1 lg:order-2">
            {whyChooseUsDetailed.map((feature) => {
              const IconComponent = iconComponents[feature.icon];
              return (
                <div
                  key={feature.id}
                  className="group bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-[#FFB400]"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-[#FFB400] to-[#D72638] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-[#2B0A12] mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;